export default __webpack_public_path__ + "static/tooltip-anatomy-dark-22e9213c52c395c848457151050aad45.png";